import Joi from 'joi';

/**
 * Schema for released filebox record validation.
 */
export const releaseFileboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
